// Id of the creation row, beside the row indexes of the view
export const NEW_ROW_ID = "new";
